import React from 'react';
import { subscribe } from 'reffects-store';
import Note from 'components/library/Note/Note';
import './Insights.css';
import { i18n } from 'utils/translate';

function Insights() {
    return (
        <div className="CampaignForm__cardWrapper__note">
            <Note>
                {i18n('create_campaign_segmentation_content_explanation')}
            </Note>
        </div>
    );
}

export default subscribe(Insights, function mapStateToProps() {
    return {};
});
